import { QUERY_NAMING } from "config/copies/query";
import { VISION_CORE_NAMING } from "config/copies/visionCore";
import { User } from "types/users";

/**
 * Top-level navigation options
 */
export enum TabChoices {
  Detectors = "Detectors",
  Review = "Review",
  Data = "Data",
  Hubs = "Hubs",
  Admin = "Admin",
  Disagreement = "Disagreement",
  Management = "Management",
  Demo = "Demo",
  Docs = "Docs",
}

export const LEFT_TABS = [
  TabChoices.Detectors,
  TabChoices.Review,
  TabChoices.Data,
  TabChoices.Hubs,
  TabChoices.Admin,
  TabChoices.Disagreement,
  TabChoices.Management,
];

export const RIGHT_TABS = [TabChoices.Demo, TabChoices.Docs];


export type TabMetadata = {
  getLabel: (user?: User) => string;
  getBadge?: (user: User) => string | null;
  opensInNewTab?: boolean;
};

export const TAB_TO_METADATA: Record<TabChoices, TabMetadata> = {
  [TabChoices.Detectors]: {
    getLabel: () => "Detectors",
  },
  [TabChoices.Review]: {
    getLabel: () => "Review",
  },
  [TabChoices.Data]: {
    getLabel: () => "Data",
  },
  [TabChoices.Hubs]: {
    getLabel: () => VISION_CORE_NAMING.uiNamePlural,
  },
  [TabChoices.Demo]: {
    getLabel: () => "Demo",
    getBadge: (user) => {
      if (!user.explore_detector) {
        return "Try Me!";
      }

      return null;
    },
  },
  [TabChoices.Docs]: {
    getLabel: () => "Docs",
    opensInNewTab: true,
  },
  [TabChoices.Admin]: {
    getLabel: () => "Admin",
  },
  [TabChoices.Disagreement]: {
    getLabel: () => "Disagreement",
  },
  [TabChoices.Management]: {
    getLabel: () => "Management",
  },
};

/**
 * I'm not sure if I like this or not - this is meant to lay out the tab heirarchy ...
 *
 * It's kinda hard because we have several desires:
 * - Go from URL -> tab heirarchy (so we can give people URL links, and the router will
 *    know which tab to highlight)
 * - Allow new routes, but don't require them to be under a tab/subtab
 * - But we also want linter hints when we've changed a route or URL, so that internal
 *    links are kept up-to-date
 * - We could have more layers of heirarchy, in theory - but maybe that's too much for a user
 *    to grok ...
 * - When a user clicks a tab or sub-tab, there could be multiple routes - so we need to
 *    decide on one of them as the default.
 * - Sub-tabs for URLs with specific object IDs (e.g., predictors/:id) may need slightly different
 *    heirarchies.
 *
 * Anyway, I don't know what the best solution is, but this is at least a start.
 */
export const TABS = {
  [TabChoices.Detectors]: {},
  [TabChoices.Review]: {},
  [TabChoices.Data]: {
    [QUERY_NAMING.uiNamePlural]: undefined,
    Inspections: undefined,
    "Image Query Info": undefined,
  },
  [TabChoices.Demo]: {
    "Quick Start": undefined,
  },
  [TabChoices.Admin]: {
    "Django Admin": undefined,
    [QUERY_NAMING.uiNamePlural]: undefined,
    Export: undefined,
    "Labeler Metrics": undefined,
  },
  [TabChoices.Docs]: {},
  [TabChoices.Disagreement]: {},
  [TabChoices.Management]: {},
  [TabChoices.Hubs]: {},
};
